/**
 * Header brand region: logo, product name, and tagline.
 *
 * @module components/HeaderBrand
 */

import React                       from 'react';
import { Link }                    from 'react-router-dom';
import { ReactComponent as Logo }  from '../images/meow.svg';
import { useI18n }                 from '../dataProviders/I18nProvider';
import config                      from '../config';

/**
 * Renders the brand section of the application header.
 *
 * @returns {React.ReactElement}
 */
export default function HeaderBrand() {
  const { t } = useI18n();

  return (
    <Link to={config.pagePaths.home} className="header-brand" style={{ textDecoration: 'none', color: 'inherit' }}>
      <span className="header-brand-logo-wrapper" data-tooltip={`v${config.app.version}`}>
        <Logo className="header-brand-logo" />
      </span>
      <div className="header-brand-text">
        <span className="header-brand-name">{t('app.name')}</span>
        <span className="header-brand-tagline">{t('app.tagline')}</span>
      </div>
    </Link>
  );
}
